import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425a37d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lost-found-container" }
const _hoisted_2 = {
  ref: "contentWrapper",
  class: "content-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "guide-message-container" }, [
  /*#__PURE__*/_createTextVNode(" ("),
  /*#__PURE__*/_createElementVNode("span", { class: "emphasis" }, " * "),
  /*#__PURE__*/_createTextVNode(")는 필수 입력 사항입니다. ")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "분실물 신고하기" }),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("section", _hoisted_4, [
            _createVNode($setup["TextInput"], {
              class: "input-container",
              name: "title",
              placeholder: "분실물명을 입력하세요",
              label: "분실물명",
              required: true,
              value: $setup.lostDetail?.title,
              maxlength: 20,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ($setup.updateLostDetail($setup.FieldKey.title, $event)))
            }, null, 8 /* PROPS */, ["value"]),
            _createElementVNode("div", null, [
              ($setup.boardedLineFilter)
                ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
                    key: 0,
                    class: "select-container",
                    label: "분실노선",
                    required: true,
                    filter: $setup.boardedLineFilter,
                    placeholder: "선택",
                    onOnSelectOption: $setup.onSelectOption
                  }, null, 8 /* PROPS */, ["filter"]))
                : _createCommentVNode("v-if", true),
              ($setup.shouldShowLineDirectInput)
                ? (_openBlock(), _createBlock($setup["TextInput"], {
                    key: 1,
                    class: "input-container board-line",
                    name: "lineName",
                    placeholder: "분실노선을 입력하세요",
                    value: $setup.lostDetail?.lineName,
                    "onUpdate:value": $setup.updateBoardedLineName
                  }, null, 8 /* PROPS */, ["value"]))
                : _createCommentVNode("v-if", true)
            ]),
            ($setup.boardedLineFilter)
              ? (_openBlock(), _createBlock($setup["TargetCalendarInput"], {
                  key: 0,
                  class: "calendar-container",
                  title: "분실일시",
                  selectedDate: $setup.lostDetail?.lostTs,
                  placeholder: "분실일시를 선택하세요",
                  dateFormat: "YYYY-MM-DD HH:mm",
                  hasTimeSelect: true,
                  required: true,
                  onOnSelectDate: $setup.onUpdateLostTs
                }, null, 8 /* PROPS */, ["selectedDate"]))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["BaseTextarea"], {
              class: "text-area-container",
              placeholder: "내용 및 특이사항을 입력하세요",
              label: "내용 및 특이사항",
              id: "note",
              required: true,
              value: $setup.lostDetail?.lostNote,
              onOnInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateLostDetail($setup.FieldKey.lostNote, $event)))
            }, null, 8 /* PROPS */, ["value"])
          ]),
          _createVNode($setup["FooterButton"], {
            title: "완료",
            disabled: !$setup.isValidRequiredFields,
            onOnClickFooterButton: $setup.submitPost
          }, null, 8 /* PROPS */, ["disabled"])
        ], 512 /* NEED_PATCH */)
      ]),
      ($setup.contentWrapper)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            class: "scroll-top-wrapper",
            container: $setup.contentWrapper
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}